export enum EntityNoteQueryType {
  Basic = 0,
  Company = 1,
  Contact = 2,
  Lead = 3,
  Hotel = 4,
  CompanyProject = 5,
  CompanyCrm = 6,
  IssueItem = 7
}
